import styled from "styled-components";

export const CardSearchContainer = styled.div`
    max-width: 545px;
    width: 100%;
    height: 515px;
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 60px;
    margin: auto;
    @media (max-width: 720px) { 
        padding: 30px; 
    }
   
`